var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "b-table",
        {
          ref: "table",
          attrs: {
            data: _vm.subunidadesCargadas,
            paginated: "",
            narrowed: "",
            "per-page": "15",
            "pagination-simple": true,
            "aria-next-label": "Siguiente Página",
            "aria-previous-label": "Página anterior",
            "aria-page-label": "Página",
            "aria-current-label": "Página actual",
          },
        },
        [
          _c("b-table-column", {
            attrs: { field: "nombre", label: "Nombre" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("p", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openPreview(props.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(props.row.nombre))]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { centered: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("p", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.descargar(props.row.id)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "is-hidden-desktop" }, [
                            _vm._v("Descargar "),
                          ]),
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-download" }),
                        ]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { centered: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("p", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openSideBySide(props.row)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "is-hidden-desktop" }, [
                            _vm._v("Abrir side by side "),
                          ]),
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-columns" }),
                        ]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("b-table-column", {
            attrs: { centered: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("p", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openPreview(props.row)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "is-hidden-desktop" }, [
                            _vm._v("Ver "),
                          ]),
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-eye" }),
                        ]
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("template", { slot: "empty" }, [
            _c("p", [_c("i", [_vm._v("No hay subunidades cargadas")])]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }